import './Filters.css';
import 'date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, MuiThemeProvider, createTheme } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';

const theme = createTheme({
  palette: {
    primary: {
      main: '#537477',
    },
  },
});

interface FilterProps {
  startDate: Date | null;
  endDate: Date | null;
  onChangeStartDate: (date: Date | null) => void;
  onChangeEndDate: (date: Date | null) => void;
  className?: string;
}

const AcronymFilters = ({
  startDate,
  endDate,
  onChangeStartDate,
  onChangeEndDate,
  className
}: FilterProps): JSX.Element => {
  return (
    <div className={`Filters ${className || ''}`}>
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container alignItems="center">
            <KeyboardDatePicker
              variant="dialog"
              format="MM/dd/yyyy"
              margin="normal"
              label="Start"
              value={startDate}
              onChange={onChangeStartDate}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              maxDate={endDate}
            />
            <KeyboardDatePicker
              variant="dialog"
              format="MM/dd/yyyy"
              margin="normal"
              label="End"
              value={endDate}
              onChange={onChangeEndDate}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              minDate={startDate}
            />
          </Grid>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </div>
  );
};

export default AcronymFilters;
